// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","MenuItem":"bhb_a bii_vt bii_ea bii_a","MenuItem__Btn":"bhb_b bii_z","MenuItem__subtitle":"bhb_c"};